module.exports = __webpack_public_path__ + "media/directory/opento_icon_hover-8faaa2b8.svg";